module.exports = __webpack_public_path__ + "static/sport/8day-logo.b735670.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/8day-logo.png
// module id = Grq/
// module chunks = 0